module.exports = {
  title: '全店返利详情',
  route: {
    path: '/marketing-tools',
    children: {
      path: 'full-store-rebate-list',
    },
  },
};
